<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                加價失敗
            </div>
            <div class="subtitle">
                加價不能向下調整
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="confirm button" @click="onResult">
                確定
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';

    export default {
        name: 'TipReduceModal',
        components: {
            'p-modal': Modal
        },
        data() {
            return {
                display: false,
            };
        },
        methods: {
            onResult() {
                this.display = false;
            },
            show() {
                this.display = true;
            },
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;

        span {
            color: rgba(244,67,54,1);
        }
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;
    }

    .buttons {
        display: flex;

        .button {
            width: 100%;
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;
            color: rgba(244,67,54,1)
        }
    }
</style>
